import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getCategoriesWithSubCategoriesUrl } from "../../utils/urls";
import AddLeadPopup from "../Leads/AddLeadPopup";
import AddLeadModal from "../common/AddLeadModal/AddLeadModal";

const ProductTab = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAddLeadOpen, setIsAddLeadOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  // Fetch categories data on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          getCategoriesWithSubCategoriesUrl + "?is_all=true"
        );
        if (response.data.success) {
          console.log(
            "response.data.data.categories",
            response.data.data.categories
          );
          let _list = response.data.data.categories?.map((item) => ({
            ...item,
            sub_category: item.sub_category?.filter(
              (sub) => sub.is_active && !sub.is_delete
            ),
          }));
          setCategories(
            _list?.sort((a, b) => {
              if (a?.sub_category?.length > b?.sub_category?.length) {
                return -1;
              } else {
                return 1;
              }
            })
          );
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  // Handle navigation to product list with category and subcategory IDs as URL params
  const handleCategoryClick = (
    category,
    subcategory,
    is_lead_add_without_product
  ) => {
    if (category?.category_id && !subcategory?.sub_category_id) {
      navigate(`/products/sub-category/${category?.category_id}`);
    } else {
      if (is_lead_add_without_product) {
        console.log("category", category);
        console.log("subcategory", subcategory);

        setSelectedCategory(category);
        setSelectedSubCategory(subcategory);
        setIsAddLeadOpen(true);
      } else {
        navigate(
          `/products/list/${category?.category_id}/${
            subcategory?.sub_category_id || ""
          }`
        );
      }
    }
  };

  if (loading) {
    return (
      <div className="page-container flex items-center p-6 text-gray-600">
        Loading...
      </div>
    );
  }

  return (
    <>
      <div className="page-container">
        <h1 className="text-xl font-semibold text-blue-600 mb-6">Products</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {categories
            // .filter((category) => category.is_active && !category.is_delete && !category?.is_lead_add_without_product)
            .filter((category) => category.is_active && !category.is_delete)
            .map((category) => (
              <div key={category.category_id} className="flex flex-col">
                <div
                  className="flex items-center gap-3"
                  style={upperHeaderStyle}
                >
                  <img
                    src={category.logo_url}
                    alt={`${category.title} logo`}
                    className="w-8 h-8 object-contain"
                  />
                  <h2
                    className="text-lg font-semibold text-gray-800 cursor-pointer hover:text-blue-600"
                    onClick={() => handleCategoryClick(category, null, false)}
                  >
                    {category.title}
                  </h2>
                </div>
                <div
                  className="flex-1 grid grid-cols-2 gap-4 items-start"
                  style={sunCategoryContainerStyle}
                >
                  {category.sub_category.length > 0 ? (
                    category.sub_category
                      .filter((sub) => sub.is_active && !sub.is_delete)
                      .map((sub) => (
                        <div
                          key={sub.sub_category_id}
                          className="p-3 bg-gray-50 rounded-md border border-gray-300 cursor-pointer hover:bg-gray-100 w-full"
                          style={subCategoryBox}
                          onClick={() =>
                            handleCategoryClick(
                              category,
                              sub,
                              category?.is_lead_add_without_product
                            )
                          }
                        >
                          <p className="text-sm text-gray-600 w-full">
                            {sub.title}
                          </p>
                        </div>
                      ))
                  ) : (
                    <p className="text-sm text-gray-500 col-span-2">
                      No subcategories available
                    </p>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* {isAddLeadOpen && (
        <AddLeadPopup
          isOpen={isAddLeadOpen}
          onClose={() => setIsAddLeadOpen(false)}
          onLeadAdded={() => {}}
          preselectedProduct={null}
          preselectedSubCategory={selectedSubCategory}
        />
      )} */}

      {isAddLeadOpen && (
        <AddLeadModal
          isOpen={isAddLeadOpen}
          onClose={() => setIsAddLeadOpen(false)}
          preselectedProduct={null}
          preSelectedCategory={{
            category_id: selectedCategory?.category_id,
            title: selectedCategory?.title,
            description: selectedCategory?.description,
            logo_url: selectedCategory?.logo_url,
            is_lead_add_without_product:
              selectedCategory?.is_lead_add_without_product,
          }}
          preSelectedSubCategory={
            selectedSubCategory
              ? {
                  sub_category_id: selectedSubCategory?.sub_category_id,
                  title: selectedSubCategory?.title,
                  description: selectedSubCategory?.description,
                  logo_url: selectedSubCategory?.logo_url,
                  category_id: {
                    category_id: selectedCategory?.category_id,
                    title: selectedCategory?.title,
                    description: selectedCategory?.description,
                    logo_url: selectedCategory?.logo_url,
                    is_lead_add_without_product:
                      selectedCategory?.is_lead_add_without_product,
                  },
                }
              : null
          }
        />
      )}
    </>
  );
};

export default ProductTab;

const upperHeaderStyle = {
  borderRadius: "0.75rem 0.75rem 0rem 0rem",
  border: "1px solid #E2EBF3",
  background: "#EAF4FF",
  padding: "0.4375rem 1rem",
};

const sunCategoryContainerStyle = {
  borderRadius: "0rem 0rem 0.5rem 0.5rem",
  border: "1px solid #E2EBF3",
  padding: "0.9375rem",
};

const subCategoryBox = {
  borderRadius: "0.5rem",
  border: "1px solid #C7D6E6",
  background: "#FAFCFE",
};
